const configSettings_Key="configSettings";
const routePath_Key="routePath";
export default {

  getConfigSettings() {
    let configSettings = sessionStorage[configSettings_Key] || localStorage[configSettings_Key];
    if (configSettings)
      return JSON.parse(configSettings);
  },
  clearConfigSettings() {
    localStorage.removeItem(configSettings_Key);
    sessionStorage.removeItem(configSettings_Key);
  },
  setConfigSettings(configSettings,persistent) {
    if (persistent) {
      localStorage[configSettings_Key] = configSettings;
    } else {
      sessionStorage[configSettings_Key] = configSettings;
    }
  },
  getRoutePath() {
    let routePathData = sessionStorage[routePath_Key] || localStorage[routePath_Key];
    if (routePathData)
      return routePathData;
  },
  setRoutePath(routePathData,persistent) {
    if (persistent) {
      localStorage[routePath_Key] = routePathData;
    } else {
      sessionStorage[routePath_Key] = routePathData;
    }
  },
  getAgGridKey(){
    var configSettings=this.getConfigSettings();
    return configSettings?configSettings.agGridKey:null;
  },
  getSiteUrl(){
    var configSettings=this.getConfigSettings();
    return configSettings?configSettings.siteUrl:null;
  },
  removeDuplicates:function(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj =>
            mapObj[prop]).indexOf(obj[prop]) === pos;
        });
  },
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
}
